import React, { Component } from "react";
import { connect } from "react-redux";

import { panelActions } from "../../actions";

class Make extends Component {
  handleMakeClick(value) {
    this.props.dispatch(panelActions.setMake(value));
  }

  render() {
    let activeClass = "";
    let activeText = "";
    if (this.props.panelStorage.isMakeActive(this.props.value)) {
      activeClass = " active";
      activeText = " aktiviert";
    }
    return (
      <button type="button"
        className={"ser-filterbut ser-iblock" + activeClass}
        onClick={this.handleMakeClick.bind(this, this.props.value)}
        aria-label={"Ausführung: " + this.props.name + activeText}
      >
        <span>{this.props.name}</span>
      </button>
    );
  }
}
export default connect(store => {
  return {
    panelStorage: store.panelStorage
  };
})(Make);
